export interface Cliente {
  id: string;
  nome: string;
  email?: string;
  telefone?: string;
  endereco?: string;
  receberCobrancaAutomatica?: boolean;
  ativo?: boolean;
  consentimentoLGPD?: boolean;
  consentimentoData?: string;
  consentimentoOrigem?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface Produto {
  id: string;
  nome: string;
  descricao?: string;
  categoria?: string;
  tamanho?: string;
  preco: number;
  custo?: number;
  controlaEstoque?: boolean;
  estoqueAtual?: number;
  estoqueMinimo?: number;
  imagemUrl?: string;
  codigoBarras?: string;
  unidadeMedida?: string;
  ativo?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface ItemPedido {
  id?: string;
  produtoId: string;
  produtoNome: string;
  quantidade: number;
  precoUnitario: number;
  custoUnitario?: number;
  lucroTotalItem?: number;
  subtotal: number;
}

export interface Pagamento {
  id?: string;
  data: string;
  valor: number;
  metodo: string;
}

export const PEDIDO_STATUS = {
  ORCAMENTO: 'Orçamento',
  PENDENTE: 'Pendente',
  PAGO_PARCIALMENTE: 'Pago Parcialmente',
  PAGO: 'Pago',
  CANCELADO: 'Cancelado',
  RETIRADA: 'Retirada',
} as const;

export type PedidoStatus = (typeof PEDIDO_STATUS)[keyof typeof PEDIDO_STATUS];

export type Periodicidade = 'SEMANAL' | 'QUINZENAL' | 'MENSAL';

export interface Recorrencia {
  id: string;
  clienteId: string;
  clienteNome?: string;
  itens: Array<{
    produtoId: string;
    produtoNome?: string;
    quantidade: number;
    precoUnitario: number;
  }>;
  periodicidade: Periodicidade;
  diaBase: number;
  dataInicio: string;
  dataFim?: string;
  ativa: boolean;
  ultimaOcorrenciaGerada?: string;
  createdAt?: string;
  updatedAt?: string;
}
export interface Pedido {
  id: string;
  codigoPedido: string;
  publicToken?: string;
  clienteId: string;
  clienteNome?: string;
  cliente?: Cliente;
  data: string;
  dataVencimento?: string;
  itens: ItemPedido[];
  subtotal?: number;
  desconto?: number;
  acrescimo?: number;
  valorTotal: number;
  lucroTotal?: number;
  margemLucro?: number;
  valorPago: number;
  saldoDevedor: number;
  status: PedidoStatus;
  pagamentos: Pagamento[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ItemPedidoNovo {
  produtoId: string;
  quantidade: number;
  precoUnitario: number;
}

export interface NovoPedido {
  clienteId: string;
  itens: ItemPedidoNovo[];
  /** true = orçamento: não baixa estoque nem vira conta a receber até converter */
  orcamento?: boolean;
  dataVencimento?: string;
  desconto?: number;
  acrescimo?: number;
}

export interface DbItem {
  PK: string;
  SK: string;
  GSI1PK?: string;
  GSI1SK?: string;
  GSI2PK?: string;
  GSI2SK?: string;
  EntityType: string;
}

export interface DbCliente extends Cliente, DbItem {}
export interface DbProduto extends Produto, DbItem {}
export interface DbPedido extends Pedido, DbItem {}

export type TipoMovimentacaoEstoque =
  'entrada_compra' | 'saida_venda' | 'retirada_uso_proprio' | 'ajuste';

export interface MovimentacaoEstoque {
  id: string;
  produtoId: string;
  tipo: TipoMovimentacaoEstoque;
  quantidade: number;
  createdAt: string;
  pedidoId?: string;
  observacao?: string;
  realizadoPor?: string;
}

export interface DbMovimentacaoEstoque extends MovimentacaoEstoque, DbItem {}

export type { Despesa } from '../schemas/despesa';
